import React from 'react';
import { Column, Row } from '../layout';
import AppDownloadButton from '../app-download-button';
import Icon from '../icon';
import { Icons } from '../../util/icons';
import * as fonts from '../../../src/util/fonts';
import colors from '../../util/colors';

const DocumentDownloader = ({ item, buStyles }: { item: any, buStyles: any;}) => {
    return (item.base64 ? (
        <a
            href={`data:application/octet-stream;base64,${item.base64}`}
            download={item.description}
            className="anchor m-0"
        >
            <Row className="reimbursement-success-file">
                <Icon
                    className="reimbursement-success-file-icon"
                    style={{ margin: '1rem' }}
                    name={Icons.DECLARATIONS}
                    width={'26'}
                    height={'26'}
                    changeViewbox
                    viewBox={'0 0 24 24'}
                />
                <Column
                    className="reimbursement-success-file-title"
                    style={{ ...fonts.M, ...fonts.Medium }}
                >
                    {item.description || item.path}
                </Column>
                <AppDownloadButton color={buStyles?.primaryColor || colors.blue} />
            </Row>
        </a>
    ) : (
        <a
            target="_blank"
            rel="noopener noreferrer"
            href={item.url}
            className="anchor m-0"
        >
            <Row className="reimbursement-success-file">
                <Icon
                    className="reimbursement-success-file-icon"
                    style={{ margin: '1rem' }}
                    name={Icons.DECLARATIONS}
                    width={'26'}
                    height={'26'}
                    changeViewbox
                    viewBox={'0 0 24 24'}
                />
                <Column
                    className="reimbursement-success-file-title"
                    style={{ ...fonts.M, ...fonts.Medium }}
                >
                    {item.description || item.path}
                </Column>
                <AppDownloadButton color={buStyles?.primaryColor || colors.blue} />
            </Row>
        </a>))
}

export default DocumentDownloader;
